import { numberMoney } from 'Data/format.js'

export function getText(used_lifetime_coverage) {
  return used_lifetime_coverage ? numberMoney(used_lifetime_coverage) : '-'
}
